import AboutYouForm from './AboutYouForm/AboutYouForm';

export { aboutYouFormInitialValues } from './AboutYouForm/aboutYouFormInitialValues';
export { aboutYouFormYupSchema } from './AboutYouForm/aboutYouFormYupSchema';

export default AboutYouForm;
